import { toast } from "react-toastify";
import { userSignUp } from "../api";

const HandleSignup = (loginForm) => {
    let data = { name: loginForm.name, username: loginForm.username, email: loginForm.email, password: loginForm.password }
    const promise = userSignUp(data);

    // Show a loading toast
    toast.promise(promise, {
        pending: "Signing up...",
    });

    // Callback for when the promise is resolved
    promise.then((res) => {
        toast.success("SignUp Sucessfull, Try Login");
    }).catch((err) => {
        toast.error(err.response.data.error || "SignUp UnSucessfull");
    });
    return;
};

export default HandleSignup;
